import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment-timezone";
import DateRangePicker from "../common/DateRangePicker";
import TextField from "../common/TextField";
import MenuItem from "../common/MenuItem";
import Button from "../common/Button";
import { checkPrivileges } from "../../Helpers";

const TicketHeader = ({
  translate,
  isShowCreateForm,
  handleAddCloseForm,
  onSearch,
  initialStatus = "",
  initialSearch = "",
}) => {
  const [status, setStatus] = useState(initialStatus);
  const [searchText, setSearchText] = useState(initialSearch);
  const [dateRangeDisplay, setDateRangeDisplay] = useState(null);
  const [dateRangeApi, setDateRangeApi] = useState(null);


  const handleDates = (e, date) => {
    if (!date?.startDate || !date?.endDate) return;

    const end = date.endDate.clone().set({
      hour: 23,
      minute: 59,
      second: 59,
      millisecond: 999,
    });

    const apiRange = {
      from: moment(date.startDate).toISOString(),
      to: end.toISOString(),
    };

    const displayRange =
      moment(date.startDate).format("YYYY-MM-DD HH:mm") +
      " - " +
      end.format("YYYY-MM-DD HH:mm");

    setDateRangeDisplay(displayRange);
    setDateRangeApi(apiRange);
  };


  const handleSearch = () => {
    if (onSearch) {
      onSearch({
        status,
        searchText,
        dateRange: dateRangeApi,
      });
    }
  };


  const handleClear = () => {
    setStatus("");
    setSearchText("");
    setDateRangeDisplay(null);
    setDateRangeApi(null);

    if (onSearch) {
      onSearch({
        status: "",
        searchText: "",
        dateRange: null,
      });
    }
  };
const isDisabledClear =
  !status &&
  !searchText &&
  !dateRangeApi?.from &&
  !dateRangeApi?.to;

  return (
    <Box
      mb={3}
      p={2}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        backgroundColor: "#F1F8EC",
        borderRadius: 2,
        boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      <Typography variant="h5" fontWeight="bold" sx={{ flexGrow: 1 }}>
        {isShowCreateForm ?  translate("createEditTicket"):translate("ticketsList")}
      </Typography>
      {!isShowCreateForm && (
        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
          <DateRangePicker
            maintenanceTop
            fill
            selectedDate={dateRangeDisplay}
            label={translate("reportFrom") + " - " + translate("reportTo")}
            translate={translate}
            onEvent={handleDates}
          />
          <TextField
            select
            label={translate("status")}
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            sx={{ minWidth: 170 }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="New">New</MenuItem>
            <MenuItem value="Assigned">Assigned</MenuItem>
            <MenuItem value="In Progress">In Progress</MenuItem>
            <MenuItem value="Awaiting Customer Response">
              Awaiting Customer Response
            </MenuItem>
            <MenuItem value="Resolved">Resolved</MenuItem>
            <MenuItem value="Closed">Closed</MenuItem>
          </TextField>
          <TextField
            label={translate("sharedSearch")}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{ minWidth: 200 }}
          />
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: "none", px: 3 }}
            onClick={handleSearch}
            disabled={isDisabledClear}
          >
            {translate("sharedSearch")}
          </Button>
          <Button
            // variant="outlined"
            color="secondary"
            sx={{ textTransform: "none", px: 3 }}
            onClick={handleClear}
            disabled={isDisabledClear}
          >
            {translate("clear")}
          </Button>
        </Box>
      )}
      {checkPrivileges("ticketCreate")&&
      <Button
      onClick={handleAddCloseForm}
      variant="contained"
      color={isShowCreateForm ? "secondary" : "success"}
      sx={{ textTransform: "none", px: 3 }}
      >
        {isShowCreateForm ? translate("back") : translate("create")}
      </Button>
      }
    </Box>
  );
};

export default TicketHeader;